export default {"src":"/_next/static/media/Key--Streamline-Iconoir.04ece9a9.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};